var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRandomPicker = function SvgRandomPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.004 18.165H12.67a1.834 1.834 0 0 0-1.834 1.834v7.334c0 1.013.82 1.834 1.834 1.834h7.334c1.013 0 1.834-.82 1.834-1.834V20c0-1.013-.821-1.834-1.834-1.834ZM25.433 21.832l3.21-3.209a2.054 2.054 0 0 0 0-2.75l-4.585-4.511a2.054 2.054 0 0 0-2.75 0l-3.136 3.136M14.504 25.5h.01M18.172 21.832h.01M22.754 14.498h.01M25.504 17.248h.01",
    stroke: "#fff",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRandomPicker;